export default {
      id: "logo-cb-full-usage",
      viewBox: "0 0 350.029 34.99",
      url: "/assets/svg/" + "sprite.svg#logo-cb-full-usage",
      toString: function () {
        return this.url;
      }
    }